import index from '../common-steps/index.vue'
const commonSteps = {
    install:function(Vue) {
        Vue.component('commonSteps', index)
    }
}
// 导出该组件
export default commonSteps